import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=85f85e1c&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmationModal.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationModal.vue?vue&type=style&index=0&id=85f85e1c&prod&scoped=true&lang=css"
import style1 from "./ConfirmationModal.vue?vue&type=style&index=1&id=85f85e1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f85e1c",
  null
  
)

export default component.exports